import * as React from "react";
import { cn } from "@/lib/utils";

/** KORI `.input`: 40px, strong hairline, ink border on focus, danger when invalid. */
const Input = React.forwardRef<HTMLInputElement, React.ComponentPropsWithoutRef<"input">>(function Input({ className, type, ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "block h-(--control-h) min-h-[max(var(--control-h),var(--touch-min))] w-full rounded-control border border-input bg-surface-raised px-(--control-pad-x) font-sans text-sm leading-[1.4] text-ink",
        "transition-[border-color] duration-(--dur-fast) ease-(--ease-quiet) placeholder:text-muted hover:border-muted focus-visible:border-action",
        "aria-invalid:border-danger disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:opacity-55 read-only:bg-surface-sunken read-only:text-muted",
        className,
      )}
      {...props}
    />
  );
});

export { Input };
